var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaignsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7437 9.38128C17.0854 9.72299 17.0854 10.277 16.7437 10.6187L10.6187 16.7437C10.277 17.0854 9.72299 17.0854 9.38128 16.7437L3.25628 10.6187C3.0854 10.4478 2.99997 10.2239 3 9.99989V5.625C3 4.17525 4.17525 3 5.625 3H10.0002C10.2241 3.00006 10.4479 3.08549 10.6187 3.25628L16.7437 9.38128ZM5.625 6.5C6.10825 6.5 6.5 6.10825 6.5 5.625C6.5 5.14175 6.10825 4.75 5.625 4.75C5.14175 4.75 4.75 5.14175 4.75 5.625C4.75 6.10825 5.14175 6.5 5.625 6.5Z",
    fill: "#525252"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignsActive);
export default __webpack_public_path__ + "static/media/campaigns-active.fa9dcc110bf29bc95d12c2ef5e3ecaf1.svg";
export { ForwardRef as ReactComponent };